<style>
.ad-vip-audio {
    position: relative;
    top: 0;
    left: 0;
}
.ad-vip-audio__link {
    position: absolute;
    bottom: .3rem;
    left: 50%;
    margin-left: -2.8rem;
    display: block;
    line-height: .88rem;
    width: 5.6rem;
    height: .88rem;
    background: #F8D498;
    border-radius: .16rem;
    text-align: center;
    font-size: .34rem;
    color: #DE3131;
}
</style>

<template>
<div v-if="href" class="ad-vip-audio">
    <k-block name="ad_vip_audio" />
    <a :href="href" class="ad-vip-audio__link v-eid-adVipAudio"><span>立即查看</span></a>
</div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'
    export default {
        name: 'ad-vip-audio',
        computed: {
            ...mapGetters(['getUrl']),
            href() {
                return this.getUrl('vipAudio')
            }
        }
    }
</script>
